import React from 'react';
import { siteData } from '../data/mock';
import { Layers, Settings, Cpu } from 'lucide-react';

const AboutSection = () => {
  const features = [
    { icon: Layers, text: siteData.about.highlights[0] },
    { icon: Settings, text: siteData.about.highlights[1] },
    { icon: Cpu, text: siteData.about.highlights[2] },
  ];

  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          {/* Section title */}
          <h2 className="heading-2 mb-6">{siteData.about.title}</h2>
          
          {/* Description */}
          <p className="body-large mb-12">{siteData.about.description}</p>

          {/* Highlights */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex flex-col items-center p-6 bg-white rounded-2xl border border-black/5 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center mb-4">
                  <feature.icon size={28} className="text-blue-600" />
                </div>
                <p className="text-base font-semibold text-slate-800">{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
